module.exports = __webpack_public_path__ + "static/nyc-2b31f29d338f5432e7425339863dda3e.png";